module.exports = __webpack_public_path__ + "img/47_22.0916a607.png";